(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AttendantDeleteController',AttendantDeleteController);

    AttendantDeleteController.$inject = ['$uibModalInstance', 'entity', 'Attendant'];

    function AttendantDeleteController($uibModalInstance, entity, Attendant) {
        var vm = this;
        vm.attendant = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Attendant.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
